export default __webpack_public_path__ + "static/media/image_8.f7558ed2.png";